import PreordersDataActions from './PreordersData/PreordersDataActions';
import PreordersCreateActions from './PreordersCreate/PreordersCreateActions';

export default {
	data: PreordersDataActions,
	create: PreordersCreateActions,
};
